import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { getNoLigne, getMaxNoLigne, bskReq } from '@core/_utils/tools.utils';
import { HeaderResult } from '@pages/results/header-result';
import { LineResult } from '@pages/results/line-result';
import { Visibility } from '@documalis/_const/const';
import { ADD_ID } from '@documalis/_const/const';
import { AutofocusDirective } from '@directives/auto-focus.directive';

import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-results',
    templateUrl: './form-results.component.html',
    styleUrls: ['./form-results.component.scss'],
    providers: [AutofocusDirective],
})
export class FormResultsComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public currentList = [];
    public validClick = false;
    public listColumns: any[];
    public selectedItem: LineResult;
    public listVisibility = [];
    public indexResultList = [];
    public displayDet: boolean = false;
    public visibility = 0;
    public isAdmin = false;
    public isBskReq: string = '';

    @Input()
    public result: HeaderResult = null;

    @Input()
    public resultItemList = [];

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public groupListUsed = [];

    @Input()
    public userListUsed = [];

    @Input()
    public indexList = [];
    @Input()
    public systemList = [];
    @Input()
    public propertiesList = [];
    @Input()
    public propBskList = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            id: null,
            name: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
            desc: null,
            visibility: this.isAdmin ? [null, [Validators.required]] : [null],
            filterType: 'idx',
            label: null,
            groupListUsed: null,
            userListUsed: null,
        });
        this.initialization();
        this.selectedItem = new LineResult();
        this.visibility = null;
    }

    ngOnInit() {
        this.currentList = this.getFilter('idx');       
        if (this.result !== null) {    
            this.result.notifyParent.subscribe(success => {
                this.resultForm.patchValue(this.result);
                this.indexResultList = JSON.parse(JSON.stringify(this.result.reqDetail));
                this.visibility = this.result.visibility;
                this.isBskReq = bskReq('Name', this.indexResultList);
            })
        }
    }

    ngOnDestroy() {
        if (this.result !== null) {            
            this.result.notifyParent.unsubscribe()
        }
    }

    public onChangeVisibility($event) {
        this.visibility = $event.value;
    }

    public changeOrder(aIdx) {
        if (this.indexResultList[aIdx].NumOrder === -1) {
            this.indexResultList[aIdx].NumOrder = 0;
            this.indexResultList[aIdx].TypeOrder = 0;
        } else {
            if (this.indexResultList[aIdx].TypeOrder === 1) {
                this.indexResultList[aIdx].NumOrder = -1;
                this.indexResultList[aIdx].TypeOrder = 0;
            } else {
                this.indexResultList[aIdx].TypeOrder = 1;
            }
        }
    }

    public updateIndex(index) {
        this.displayDet = true;
        this.selectedItem.Clear();
        Object.assign(this.selectedItem, index);
        this.selectedItem = this.setDetailIndex(index, this.selectedItem);
        this.selectedItem.ListOrder = this.updateOrderList(this.indexResultList.length);
    }

    private setDetailIndex(aIndex, aSelectedItem) {
        var wItem: LineResult;
        var wIndex = -1;
        wItem = new LineResult();
        wIndex = getNoLigne(this.indexResultList, aIndex.noligne);
        Object.assign(wItem, aSelectedItem);
        Object.assign(wItem, this.indexResultList[wIndex]);
        return wItem;
    }

    public deleteIndex(aIndex) {
        var wIndex = -1;
        wIndex = getNoLigne(this.indexResultList, aIndex.noligne);
        this.indexResultList.splice(wIndex, 1);
        this.isBskReq = bskReq('Name', this.indexResultList);
    }

    public moveToTarget(event) {
        this.displayDet = true;
        this.selectedItem.Clear();
        Object.assign(this.selectedItem, event.data);
        this.selectedItem.noligne = ADD_ID;
        this.selectedItem.ListOrder = this.updateOrderList(this.indexResultList.length + 1);
    }

    private updateOrderList(aIndex) {
        let adata = [];
        adata.push({ label: this.translate.instant('No_Sort'), value: -1 });
        for (let i = 0; i < aIndex; i++) {
            adata.push({ label: i.toString(), value: i });
        }
        return adata;
    }

    public validItem(event) {
        this.displayDet = false;
        if (event.noligne === ADD_ID) {
            this.addToListIndex(event);
        } else {
            this.updateListIndex(event);
        }
        this.isBskReq = bskReq('Name', this.indexResultList);
    }

    public closeCriteria() {
        this.displayDet = false;
    }

    private addToListIndex(aData) {
        let wIndex: any;
        var wLign = -1;
        wLign = getMaxNoLigne(this.indexResultList);
        wLign++;
        wIndex = this.setCriteria(aData, wLign);
        this.indexResultList.push(wIndex);
    }

    private updateListIndex(aData) {
        var wIndex = -1;
        wIndex = getNoLigne(this.indexResultList, aData.noligne);
        if (wIndex !== -1) {
            this.indexResultList[wIndex] = this.setCriteria(aData, aData.noligne);
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Err_IdxDoc'));
        }
    }

    private setCriteria(aData, aNolign) {
        let wIndex: any;
        wIndex = new Object();
        wIndex = {
            Name: aData.Name,
            Label: aData.Label,
            noligne: aNolign,
            NumOrder: aData.NumOrder,
            TypeOrder: aData.TypeOrder,
            Type: aData.Type,
            ThumbInfo: aData.ThumbInfo,
        };
        return wIndex;
    }

    public onFilterClick(event) {
        this.currentList = [];
        this.currentList = this.getFilter(event);
    }

    public validate(aDuplicate) {
        let wRequest: any;

        if (!this.isAdmin) {
            this.resultForm.value.visibility = 2;
            this.resultForm.value.userListUsed = [];
            this.resultForm.value.userListUsed.push(this.auth.getUser());
        }

        wRequest = new Object();
        wRequest = {
            duplicate: aDuplicate,
            entete: this.resultForm.value,
            detail: this.indexResultList,
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.indexResultList.length === 0) {
            this._messageService.addErrorNoStick(this.translate.instant('NoIdx'));
            return;
        }
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private getFilter(aType) {
        let wResult = [];
        const type = {
            idx: this.getList(this.indexList),
            doc: this.getList(this.propertiesList),
            bsk: this.getList(this.propBskList),
            sys: this.getList(this.systemList),
        };
        if (type[aType]) {
            wResult = type[aType]();
        }
        return wResult;
    }

    private getList(aList) {
        return () => {
            return aList;
        };
    }

    private initialization() {
        this.listVisibility = [];
        this.keys = {
            name: {
                label: this.translate.instant('Name'),
                pattern: '',
            },
            visibility: {
                label: this.translate.instant('Visibility'),
                pattern: '',
            },
        };

        this.listColumns = [
            {
                field: 'Name',
                header: this.translate.instant('Name'),
            },
            {
                field: 'Label',
                header: this.translate.instant('Label'),
            },
        ];

        Visibility.forEach(item => {            
            this.listVisibility.push({ label: item.name, value: item.id });
        });  
    }
}
